<div class="table-relatorios">
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div style="padding-top: 4px"></div>
  }
  <mat-card appearance="outlined">
    <div class="table-container">
      <table
        #table
        mat-table
        [dataSource]="dataSource()"
        matSort
        matSortStart="desc"
        (matSortChange)="onSortChange($event)"
        class="mat-elevation-z8 responsive-table"
      >
        <!-- Dynamic columns based on configuration -->
        @for (column of visibleColumns; track column.key) {
          <ng-container [matColumnDef]="column.key">
            @if (column.sortable) {
              <th
                mat-header-cell
                *matHeaderCellDef
                [mat-sort-header]="column.key"
              >
                {{ column.label }}
              </th>
            } @else {
              <th mat-header-cell *matHeaderCellDef>
                {{ column.label }}
              </th>
            }
            <td mat-cell *matCellDef="let element">
              @switch (column.type) {
                @case ("date") {
                  {{ formatDate(element[column.key]) }}
                }
                @case ("status") {
                  @if (element[column.key]) {
                    <mat-chip
                      [class]="
                        config().statusClassFunction
                          ? config().statusClassFunction!(
                              element[column.key].code
                            )
                          : ''
                      "
                    >
                      {{ element[column.key].description }}
                    </mat-chip>
                  }
                }
                @case ("cities") {
                  @if (element[column.key] && element[column.key].length > 0) {
                    <span
                      [matTooltip]="element[column.key].join(', ')"
                      matTooltipPosition="above"
                      style="cursor: pointer; padding-left: 0; padding-right: 0"
                    >
                      {{ element[column.key][0] }}
                      @if (element[column.key].length > 1) {
                        <span> (+{{ element[column.key].length - 1 }}) </span>
                      }
                    </span>
                  } @else {
                    -
                  }
                }
                @default {
                  {{ element[column.key] }}
                }
              }
            </td>
          </ng-container>
        }

        <!-- Actions column -->
        @if (config().showActionsColumn && visibleActions.length > 0) {
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Ações</th>
            <td mat-cell *matCellDef="let element">
              @if (shouldShowActionsMenu(visibleActions, element)) {
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  aria-label="Menu de ações"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  @for (action of visibleActions; track action.key) {
                    @if (shouldShowActionForItem(action, element)) {
                      <button
                        mat-menu-item
                        (click)="executeAction(action, element, $event)"
                      >
                        <mat-icon>{{ action.icon }}</mat-icon>
                        <span>{{ action.label }}</span>
                      </button>
                    }
                  }
                </mat-menu>
              }
            </td>
          </ng-container>
        }
        <!-- Individual action columns (when showActionsColumn is false) -->
        @if (!config().showActionsColumn) {
          @for (action of visibleActions; track action.key) {
            <ng-container [matColumnDef]="action.key">
              <th mat-header-cell *matHeaderCellDef>{{ action.label }}</th>
              <td mat-cell *matCellDef="let element">
                @if (shouldShowActionForItem(action, element)) {
                  <button
                    mat-icon-button
                    [attr.aria-label]="action.label"
                    (click)="executeAction(action, element, $event)"
                  >
                    <mat-icon>{{ action.icon }}</mat-icon>
                  </button>
                }
              </td>
            </ng-container>
          }
        }

        <!-- Table header and rows -->
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- No data row -->
        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell"
            [attr.colspan]="displayedColumns.length"
            style="text-align: center"
          >
            Nenhum dado disponível
          </td>
        </tr>
      </table>
    </div>
  </mat-card>
  <!-- Pagination -->
  <mat-paginator
    #paginator
    [length]="length()"
    (page)="onPageChange($event)"
    showFirstLastButtons
    aria-label="Selecionar página"
  ></mat-paginator>
</div>
